import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import KeyValueListView from '../../common/key-value-list-view';
import { shouldAbbreviateNumber, shouldTruncateNumber } from '../../../utils/abbrev-number';

class AbbreviatedGroup extends PureComponent {
  static propTypes = {
    data: PropTypes.object,
    dataDefinitions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      key: PropTypes.string,
      type: PropTypes.string,
    })),
    abbreviationRules: PropTypes.object.isRequired,
    renderTopSeparator: PropTypes.bool,
    renderBottomSeparator: PropTypes.bool,
  };

  static defaultProps = {
    data: {},
    dataDefinitions: [],
    renderTopSeparator: false,
    renderBottomSeparator: true,
  };

  getAbbreviatedData() {
    const {
      data,
      dataDefinitions,
      abbreviationRules,
      messages,
    } = this.props;

    if (!Object.keys(data).length || !dataDefinitions.length) {
      return [];
    }

    const abbreviatedData = [];

    dataDefinitions.forEach(({ key, label, type, abbreviationRule, isPhone, isTablet }) => {
      const value = data[key];

      if (typeof value !== 'number') {
        return;
      }

      const { maxDigits, maxDecimals, maxDigitsIncludeDecimals } =
        abbreviationRule || abbreviationRules[key] || abbreviationRules.default;

      const shouldShowData =
        shouldAbbreviateNumber(value, maxDigits, maxDecimals, maxDigitsIncludeDecimals) ||
        shouldTruncateNumber(value, maxDigits, maxDecimals, maxDigitsIncludeDecimals);
      if (value != null && shouldShowData) {
        abbreviatedData.push({
          value,
          label: label.replace(/\n/g, ''),
          type,
          key,
          isPhone,
          isTablet,
        });
      }
    });

    return abbreviatedData;
  }

  render() {
    const abbreviatedData = this.getAbbreviatedData();

    if (!abbreviatedData.length) {
      return null;
    }

    const {
      data,
      renderTopSeparator,
      renderBottomSeparator,
      messages
    } = this.props;

    return (
      <KeyValueListView
        detailsGroups={[abbreviatedData]}
        row={data}
        renderFirstSeparator={renderTopSeparator}
        renderLastSeparator={renderBottomSeparator}
        messages={messages}
      />
    );
  }
}

export default AbbreviatedGroup;
